import { Component, OnInit } from '@angular/core';
import { BaseTabsContainer, TabsContainerService, UserService } from 'yt-ng-framework';
import { User } from './user';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'yt-user-tabs',
  templateUrl: './user-tabs.component.html',
  providers: [
    TabsContainerService
  ]
})
export class UserTabsComponent extends BaseTabsContainer<User> implements OnInit {

  constructor(
    public tabsContainerService: TabsContainerService<User>,
    protected activatedRoute: ActivatedRoute,
    protected userService: UserService
  ) {
    super(tabsContainerService, activatedRoute, userService);
   }

  ngOnInit() {
    super.ngOnInit();
  }

}
